import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const PluginPage: React.FC = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <SEO
        title="PWC Plugins & NAM Skins | PWC Profiles"
        description="Explore PWC Skin V1 and PWC Skin V2 for Neural Amp Modeler. High-performance, photorealistic re-skins and signal processing suites."
        image="https://www.pwc-profiles.com/images/plugins/pwc_nam_skin_iic/distance_shot2.jpg"
        url="https://www.pwc-profiles.com/plugins"
      />
      <section className="bg-cover bg-center flex justify-center pt-4">
        <div className="text-center pt-20 px-6 rounded-lg max-w-[1000px] flex flex-col items-center">
          <p className="uppercase tracking-[0.2em] text-sm text-blue-300">
            Plugins
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold gradient-text max-w-3xl mt-4">
            Choose Your PWC Skin Version
          </h1>
          <p className="mt-8 text-lg sm:text-xl max-w-2xl text-gray-200">
            We now offer two plugin pages. Explore the original release as
            PWCskinV1 or discover the updated PWCskinV2 experience.
          </p>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          <article className="rounded-xl border border-blue-500/40 bg-gradient-to-b from-blue-950/30 via-white/[0.02] to-white/[0.04] p-8 flex flex-col relative overflow-hidden shadow-[0_0_25px_rgba(59,130,246,0.15)] transition-all duration-300 hover:border-blue-400/60">
            {/* NEW Badge at top-right corner */}
            <div className="absolute top-4 right-4 flex items-center gap-1.5 px-3 py-1 rounded-full bg-gradient-to-r from-cyan-500 via-blue-600 to-indigo-600 text-white text-xs font-black tracking-wider uppercase shadow-[0_0_15px_rgba(34,211,238,0.5)] border border-cyan-300/30">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-300 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-300"></span>
              </span>
              <span>NEW</span>
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              <h2 className="text-3xl font-bold gradient-text">
                PWC NAM SKIN II
              </h2>
              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-gradient-to-r from-cyan-500/20 via-blue-500/20 to-indigo-500/20 border border-cyan-400/40 text-cyan-300 text-xs font-extrabold tracking-wide uppercase shadow-[0_0_10px_rgba(34,211,238,0.2)]">
                <svg
                  className="w-3 h-3 text-cyan-300 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                </svg>
                v2.0
              </span>
            </div>
            <p className="mt-4 text-gray-300 flex-grow">
              Version 2 of our NAM skin adds great new features like:
              <ul className="mt-4 space-y-2 list-disc ml-4 text-gray-300 flex-grow">
                <li>
                  {" "}
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  NAM A2 support
                </li>
                <li>
                  {" "}
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  Reverbs
                </li>
                <li>
                  {" "}
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  Delay
                </li>
                <li>
                  {" "}
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  Tuner
                </li>
                <li>
                  {" "}
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  Spatial Audio
                </li>
                <li>
                  {" "}
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  All in a sleek new interface.
                </li>
                <li>
                  <span className="text-cyan-400">
                    <b>NEW</b>
                  </span>{" "}
                  MacOS support
                </li>
              </ul>
            </p>
            <img
              src="/images/plugins/pwc_nam_skin_iic/macbook_iic.webp"
              className="mt-8 h-64 w-full object-cover rounded-lg border border-white/10"
            />
            <Link
              to="/plugins/pwcskinv2"
              className="mt-8 inline-flex justify-center rounded-full px-6 py-3 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 transition-all duration-200 font-semibold shadow-lg shadow-blue-600/30 hover:shadow-blue-500/50"
            >
              Show Details
            </Link>
          </article>
          <article className="rounded-xl border border-white/15 bg-white/[0.03] p-8 flex flex-col">
            <h2 className="text-3xl font-bold gradient-text">PWC NAM SKIN</h2>
            <p className="mt-4 text-gray-300 flex-grow">
              Discover a Re-Skin of the original NAM plugin, same features, new
              look.
            </p>{" "}
            <img
              src="/images/plugins/pwc_nam_skin/nam_skin_window_laptop.png"
              className="mt-8 h-64 w-full object-cover rounded-lg"
            />
            <Link
              to="/plugins/pwcskinv1"
              className="mt-8 inline-flex justify-center rounded-full px-6 py-3 bg-blue-600 hover:bg-blue-500 transition-colors font-semibold"
            >
              Show Details
            </Link>
          </article>
        </div>
      </section>
    </div>
  );
};

export default PluginPage;
